module.exports = __webpack_public_path__ + "img/PT.6a8dffa3.svg";